module.exports = __webpack_public_path__ + "img/treppenabgang2.675d8d17.webp";